import React, { createContext, FC, useState, useContext, useEffect } from 'react';
import { BreakPoint, findBreakPoint } from './util';
import { useDebounce } from '@clover-util/use-debounce';

export type WindowContextState = {
  breakpoint: BreakPoint;
  width: number;
  isDesktop: boolean;
}

const WindowSizeContext = createContext<WindowContextState>({} as unknown as WindowContextState);
// eslint-disable-next-line
WindowSizeContext.displayName = 'WindowSizeContext';

export { BreakPoint };

export const WindowSizeProvider: FC = ({ children }) => {
  const [breakpoint, setBreakpoint] = useState<BreakPoint>(findBreakPoint());
  const [width, setWidth] = useState(window.innerWidth);

  const onResize = useDebounce(() => {
    setBreakpoint(findBreakPoint());

    // out of clientWidth, matchMedia and innerWidth, innerWidth is the fastest. test it yourself here: https://www.measurethat.net/Benchmarks/Show/6347/0/matchmedia-vs-clientwidth-vs-innerwidth
    setWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, [onResize]);

  return (
    <WindowSizeContext.Provider value={{ breakpoint, width, isDesktop: width > BreakPoint.TABLET }}>
      {children}
    </WindowSizeContext.Provider>
  );
};

export function useWindowSize() {
  return useContext(WindowSizeContext);
}
